import { PhoneNumber } from "../types/verificationCode";

export const isUserVerified = ({
  phone_number,
}: {
  phone_number?: PhoneNumber;
}) => {
  return Boolean(phone_number?.verified_at);
};
